import { NextSeo } from 'next-seo';
import React from 'react';
import FrikdUpFishiesDetail from '@/components/sk-club/games/FrikdUpFishiesDetail';
import config from '@/config';

function FrikdUpFishiesPage() {
  const title = `Frik'd Up Fishies - SK Club | ${config.siteName}`;
  const description = "Kitties taking care of fish. What could go wrong? A virtual pet aquarium with hand-drawn fish, care actions, and a coin economy. Available on iOS & Android.";
  const url = 'https://www.shittykitties.art/sk-club/frikd-up-fishies';
  const ogImage = 'https://www.shittykitties.art/sk-club/og-frikd-up-fishies.png';

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          type: 'website',
          url,
          title,
          description,
          images: [
            {
              url: ogImage,
              width: 1200,
              height: 630,
              alt: "Frik'd Up Fishies - Available on iOS & Android",
            },
          ],
        }}
        twitter={{ cardType: 'summary_large_image' }}
      />
      <FrikdUpFishiesDetail />
    </>
  );
}

export default FrikdUpFishiesPage;
